const globals = {}

export const setGlobal = ( key, value ) => {
    globals[key] = value
}

export default globals